import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    }
});

class ScheduledCourseForm extends Component {

    handleChange = field_name => event => {

        // console.log(field_name, event.target.value)

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        this.props.updateScheduledCourseForm(update_data);
    }

    render() {
        const { classes, view_type, theme, scheduledCourse, allInstructors, currentInstructors, x } = this.props;

        // Constant below is simply a helper to go ahead and assign props that do
        //      not differ between the text fields without needing to repeat them.

        const sharedTextFieldProps = {
            InputProps: {
                readOnly: true,
                disableUnderline: true,
                className: this.props.classes.readOnlyMargin
            },
            variant: 'standard',
            margin: 'normal',
            className: classes.textField
        }

        return (
            <div className="p-24">

                <Grid container spacing={24}>
                    <Grid item xs={8}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    id="CourseName"
                                    label="Course Name"
                                    value={scheduledCourse.CourseName}
                                    onChange={this.handleChange('CourseName')}
                                    {...sharedTextFieldProps}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="StartDate"
                                    label="Start Date"
                                    value={moment(scheduledCourse.StartDate).format('MM-DD-YYYY')}
                                    onChange={this.handleChange('StartDate')}
                                    {...sharedTextFieldProps}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="EndDate"
                                    label="End Date"
                                    value={moment(scheduledCourse.EndDate).format('MM-DD-YYYY')}
                                    onChange={this.handleChange('EndDate')}
                                    {...sharedTextFieldProps}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="StudentCount"
                                    label="Student Count"
                                    className={classes.textField}
                                    value={scheduledCourse.StudentCount + '/' + scheduledCourse.CourseSizeLimit}
                                    onChange={this.handleChange('None')}
                                    {...sharedTextFieldProps}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            style={{ marginLeft: '6px' }}
                                            checked={(scheduledCourse.OpenEnrollment === 1 || scheduledCourse.OpenEnrollment === true)}
                                            onChange={(view_type === 'detail') ? undefined : this.handleChange('OpenEnrollment')}
                                            disableRipple={view_type === 'detail'}
                                            value="Active"
                                            color="primary"
                                        />
                                    }
                                    label="Open Enrollment"
                                />
                            </Grid>
                        </form>

                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getScheduedCourse: Actions.getScheduledCourse,
        updateScheduledCourseForm: Actions.updateScheduledCourseForm

    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
        scheduledCourse: scheduledCourseApp.scheduledCourses.currentScheduledCourse,
        allInstructors: scheduledCourseApp.scheduledCourses.allInstructors,
        currentInstructors: scheduledCourseApp.scheduledCourses.currentInstructors,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduledCourseForm)));



// WEBPACK FOOTER //
// src/main/content/scheduled_course/ScheduledCourseForm.js